import { ApolloProvider } from '@apollo/client';
import { useEffect } from 'react';
import { APP_NAME, APP_NAMES } from '../../../shared/lib/constants';
import { MainProvider } from '../../../shared/lib/providers/MainProvider';
import { client } from './apollo';
import { AppProvider } from './contexts/AppContext/AppProvider';
import MainRoutes from './routes';
import { BrowserRouter } from 'react-router-dom';

/**
 * App is the main component that represents the Portal.
 *
 * @component
 * @returns {JSX.Element} The JSX element representing the Portal.
 */
export const App = () => {
  useEffect(() => {
    localStorage.setItem(APP_NAME, APP_NAMES.PORTAL);
  }, []);

  return (
    <MainProvider appName={APP_NAMES.PORTAL}>
      <ApolloProvider client={client}>
        <BrowserRouter basename="portal">
          <AppProvider>
            <MainRoutes />
          </AppProvider>
        </BrowserRouter>
      </ApolloProvider>
    </MainProvider>
  );
};
